import React, { useEffect, useState } from 'react';
import useAxios from '../axios/useAxios';
import HomeLoader from '../components/loader/HomeLoader';
import { useSelector } from 'react-redux';

const EdenredScreen = () => {
  let state;
  const axiosInstance = useAxios();
  const code = new URLSearchParams(window.location.search).get('code');
  const session = new URLSearchParams(window.location.search).get(
    'session_state',
  );
  const user = useSelector((state) => state.user);
  if (window.location.pathname === '/config/edenred') state = 'config';
  else state = 'payment';
  
  useEffect(() => {
    axiosInstance
      .put('/edenred/info', {
        code: code,
        session: session,
        user: user,
        state: state,
      })
      .then((response) => {
        const newEdenred = JSON.parse(localStorage.getItem('user')) || {};
        newEdenred.edenred = response.data;
        localStorage.setItem('user', JSON.stringify(newEdenred));
      })
      .catch((error) => {
        console.error('Edenred connectino failed', error);
        const newEdenred = JSON.parse(localStorage.getItem('user')) || {};
        newEdenred.edenred = { error: true };
        localStorage.setItem('user', JSON.stringify(newEdenred));
      })
      .finally(() => {
        window.close();
      });
  }, []);

  return <HomeLoader />;
};

export default EdenredScreen;
